import React, { Suspense } from 'react';
import { observer } from 'mobx-react';
import loadable from '@loadable/component';
import { Loadable } from 'components/Loadable';

import { Route, Switch } from 'react-router-dom';
import * as paths from 'Paths';


const OverviewRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/partners/overview" */
    'routes/Partners/OverviewRoute'
  )
));


const MetricsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/partners/metrics" */
    'routes/Partners/MetricsRoute'
  )
));


const EditPartnerRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/partners/edit" */
    'routes/Partners/EditPartnerRoute'
  )
));

const CommissionsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/partners/commissions" */
    'routes/Partners/CommissionsRoute'
  )
));

const PayoutsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/partners/payouts" */
    'routes/Partners/PayoutsRoute'
  )
));

const AgencyRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/partners/agency" */
    'routes/Partners/AgencyRoute'
  )
));

const UpdateAgencyRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/partners/update-agency" */
    'routes/Partners/UpdateAgencyRoute'
  )
));

const DealsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/partners/deals" */
    'routes/Partners/DealsRoute'
  )
));

const DealRedemptionRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/partners/deal-redemption" */
    'routes/Partners/DealRedemptionRoute'
  )
));


const getPartnersRoutes = () => {
  return [
    {path: paths.getPathPartnerOverview(), component: OverviewRoute},
    {path: paths.getPathEditPartner(), component: EditPartnerRoute},
    {path: paths.getPathPartnerMetrics(), component: MetricsRoute},
    {path: paths.getPathPartnerCommissions(), component: CommissionsRoute},
    {path: paths.getPathPartnerPayouts(), component: PayoutsRoute},

    {path: paths.getPathAgency(), render: (props) => <AgencyRoute {...props} />},
    {path: paths.getPathAddAgency(), render: (props) => <UpdateAgencyRoute {...props} isCreate={true} />},
    {path: paths.getPathEditAgency(), render: (props) => <UpdateAgencyRoute {...props} isCreate={false} />},

    {path: paths.getPathPartnerDeals(), component: DealsRoute},
    {path: paths.getPathPartnerDealRedemption(":dealId"), component: DealRedemptionRoute},
  ]
}



export { getPartnersRoutes };
